module.exports = __webpack_public_path__ + "static/media/banner-photp-mobile.2feaa5f1.jpg";